// Charity Shopify Theme JS
document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Add to cart quantity validation
  document.querySelectorAll('input[type="number"][name="quantity"]').forEach(function(input) {
    input.addEventListener('change', function() {
      if (parseInt(this.value) < 1) this.value = 1;
    });
  });
});